export function ResumeLink({ text }: { text?: string }) {
  return (
    <a href="/Vincent-Liaw-Resume-2026.pdf" target="_blank" rel="noopener noreferrer">
      {text ?? 'Resume'}
    </a>
  );
}